;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('forms', forms)

  /* @ngInject */
  function forms () {
    return {
      restrict: 'EA',
      scope: {
        missingField: '<',
        field: '<',
        readOnly: '<',
        mandatory: '<',
        onChange: '&',
        onReady: '&',
        enableCheckboxHideUnchecked: '<',
        onClick: '<'
      },
      templateUrl: '/core/directives/forms/forms-directive.html?$$REVISION$$',
      controller: 'FormsController'
    }
  }
})()
